import type { ExpectedFormat } from './ExpectedFormat'
import { expectedFormatKey } from './expectedFormatKey'

export const isExpectedFormat = (value: string): value is ExpectedFormat =>
  Object.hasOwn(expectedFormatKey, value)
